import type { VacationRequestsRepositoryT } from "../../domain/ports/vacationRequests.repository";

type GetRequestFilesParamsT = {
  vacationRequestsRepository: VacationRequestsRepositoryT;
  requestId: string;
  colaboraInstanceId: string;
};

export const getRequestFiles = async ({
  vacationRequestsRepository,
  requestId,
  colaboraInstanceId,
}: GetRequestFilesParamsT) => {
  return await vacationRequestsRepository.getRequestFiles(
    requestId,
    colaboraInstanceId,
  );
};
